module.exports = __webpack_public_path__ + "static/ISO13485-1ded4c3ccf8a0c34ff200022b9bbe537.jpeg";